import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type Params } from '@/infra/services/checkout/cart/remove-service-from-cart';
import { useGlobalStore } from '@/presenters/store/global';

interface UseRemoveServiceFromCart {
  onError?: () => void;
  onSuccess?: () => void;
}

const useRemoveServiceFromCart = (
  props: Readonly<UseRemoveServiceFromCart> = {}
) => {
  const queryClient = useQueryClient();
  const cartId = useGlobalStore((store) => store.session?.cartId);

  const { onError, onSuccess } = props;

  const result = useMutation({
    mutationFn: (data: Omit<Params, 'cartId'>) =>
      Services.Checkout.Cart.removeServiceFromCart({
        ...data,
        cartId: cartId!,
      }),
    onError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart-summary', cartId] });
      queryClient.invalidateQueries({ queryKey: ['cart-shipments', cartId] });

      onSuccess?.();
    },
  });

  return result;
};

export default useRemoveServiceFromCart;
